import { createContext, useContext } from "react";

export type OperationOutcome = "completed" | "failed" | "timeout";

export interface OperationsContextValue {
  trackOperation: (operationUuid: string, label: string) => void;
  failOperation: (operationUuid: string) => void;
  waitForOperation: (operationUuid: string, timeoutMs: number) => Promise<OperationOutcome>;
}

const defaultValue: OperationsContextValue = {
  trackOperation: () => {},
  failOperation: () => {},
  waitForOperation: () => Promise.resolve("timeout"),
};

export const OperationsContext = createContext<OperationsContextValue>(defaultValue);

export const useOperations = (): OperationsContextValue => useContext(OperationsContext);
